import { CopilotConversation } from 'models/copilot/copilotConversation';
import { TenantProcessStatus } from 'models/copilot/tenantProcessStateBase';

// Mirror of ProcessStateAutomationDrafting.AutomationDraftingStage (isoplanner-api)
export enum AutomationDraftingStage {
  Proposal = 0,
  Selection = 1,
  Refinement = 2,
  Testing = 3,
  Approving = 4,
  Scheduling = 5,
  Completed = 6,
}

// Mirror of AutomationReadiness (isoplanner-api)
export enum AutomationReadiness {
  Ready = 0,
  NeedsConnection = 1,
  NewCapability = 2,
}

// The preview commands a stage offers (ProcessStateAutomationDrafting.Actions) and the commands the client sends
export const automationDraftingCommandAccept = 'accept';
export const automationDraftingCommandTest = 'test';

// One automation candidate of the proposal: the server's id (c1..c5) is what the selection answers with
export class AutomationCandidate {
  id: string = '';

  title: string = '';

  proves: string = '';

  evidenceSource: string = '';

  kind: string = 'pass_fail';

  checkKey: string = '';

  readiness: AutomationReadiness = AutomationReadiness.Ready;

  capabilityKey?: string;

  missingCapabilities: string[] = [];

  existingSkillKey?: string;
}

// The draft as SkillControl's drafter proposed it
export class AutomationDraftProposal {
  isRevision: boolean = false;

  key?: string;

  name?: string;

  description?: string;

  category?: string;

  skillMd: string = '';

  skillYaml: string = '';

  changeSummary?: string;

  proposedVersion?: string;

  notes: string[] = [];

  // the proposed skill.yaml's errors as readable lines; empty when it validates (phase 32 D32-7)
  yamlErrors: string[] = [];
}

export class AutomationDraftState {
  proposal?: AutomationDraftProposal;

  skillId?: string;

  versionId?: string;

  version?: string;

  versionStatus?: string;

  skillKey?: string;

  skillName?: string;

  testCaseCount: number = 0;

  lastTestOutcome?: string;
}

export class AutomationApprovalState {
  submitted: boolean = false;

  versionStatus?: string;

  approved: boolean = false;

  published: boolean = false;

  needsAdmin: boolean = false;

  reason?: string;
}

export class AutomationWireState {
  wired: boolean = false;

  integrationId: number = 0;

  kpiId: number = 0;

  checkKey?: string;

  kpiName?: string;

  error?: string;
}

export class AutomationScheduleState {
  choice?: string;

  scheduleId?: string;

  error?: string;
}

/**
 * The state of the SkillControl drafting process (phase 27): which stage is active, whether the user may type in it,
 * the preview commands it offers, the candidates, the draft and what the final stages made. The run status travels
 * with it so a definition can end the process when the server completed or failed it in the same request.
 */
export class TenantProcessStateAutomationDrafting {
  status: TenantProcessStatus = TenantProcessStatus.InProgress;

  stage: AutomationDraftingStage = AutomationDraftingStage.Proposal;

  inputAllowed: boolean = false;

  actions: string[] = [];

  entityType: number = 0;

  entityId: number = 0;

  entityCode?: string;

  candidates: AutomationCandidate[] = [];

  selectedCandidateId?: string;

  draft?: AutomationDraftState;

  approval?: AutomationApprovalState;

  wire?: AutomationWireState;

  schedule?: AutomationScheduleState;

  conversation: CopilotConversation = new CopilotConversation();

  get selectedCandidate(): AutomationCandidate | undefined {
    return this.candidates.find((candidate) => candidate.id === this.selectedCandidateId);
  }
}
